var exports = {
  "tB": "ContextMenu.module__backdrop___c29sd2",
  "D8": "ContextMenu.module__contextMenuPositioner___c29sd2",
  "He": "ContextMenu.module__contextMenu___c29sd2",
  "KY": "ContextMenu.module__menuScroller___c29sd2",
  "NC": "ContextMenu.module__menuScrollerContent___c29sd2",
  "AS": "ContextMenu.module__item___c29sd2",
  "r9": "ContextMenu.module__disabled___c29sd2",
  "OR": "ContextMenu.module__danger___c29sd2",
  "Fx": "ContextMenu.module__itemIcon___c29sd2",
  "IR": "ContextMenu.module__itemLabel___c29sd2",
  "Ah": "ContextMenu.module__itemWithShortcut___c29sd2",
  "g$": "ContextMenu.module__itemShortcut___c29sd2",
  "ED": "ContextMenu.module__itemShortcutHidden___c29sd2",
  "dP": "ContextMenu.module__itemLabelContainer___c29sd2",
  "b": "ContextMenu.module__itemLabelText___c29sd2",
  "Lo": "ContextMenu.module__itemHint___c29sd2",
  "fV": "ContextMenu.module__submenuCaret___c29sd2",
  "me": "ContextMenu.module__separator___c29sd2",
  "Os": "ContextMenu.module__group___c29sd2",
  "_0": "ContextMenu.module__selectableSection___c29sd2",
  "dl": "ContextMenu.module__checkboxItem___c29sd2",
  "fb": "ContextMenu.module__checkboxIndicator___c29sd2",
  "kv": "ContextMenu.module__checkbox___c29sd2",
  "xY": "ContextMenu.module__checkboxChecked___c29sd2",
  "AM": "ContextMenu.module__groupLabel___c29sd2",
  "HG": "ContextMenu.module__submenuPopover___c29sd2",
  "a": "ContextMenu.module__submenuScroller___c29sd2",
  "pT": "ContextMenu.module__quickReactionsGroup___c29sd2",
  "gV": "ContextMenu.module__quickReactionItem___c29sd2",
  "z5": "ContextMenu.module__quickReactionShortcut___c29sd2",
  "dd": "ContextMenu.module__quickReactionTooltipContent___c29sd2",
  "Vx": "ContextMenu.module__quickReactionTooltipHint___c29sd2",
  "hH": "ContextMenu.module__emojiSubmenuIcon___c29sd2",
  "XN": "ContextMenu.module__emojiSubmenuImg___c29sd2",
};

module.exports = exports;
